module.exports = {
  ...require('./tokens.common'),
  ...require('../themes/themes'),
  ...require('../themes/sets'),
};
